import ABTesting from "../AbTesting"
import Ad from "../Ad"
import AddressBook from "../AddressBook"
import Admin from "../Admin"
import Alarm from "../Alarm"
import AlarmOff from "../AlarmOff"
import AlarmRing from "../AlarmRing"
import AlertCircle from "../AlertCircle"
import AlertTriangle from "../AlertTriangle"
import Analytics from "../Analytics"
import Announcement from "../Announcement"
import AppStore from "../AppStore"
import AppStoreFilled from "../AppStoreFilled"
import Archive from "../Archive"
import ArrowDown from "../ArrowDown"
import ArrowDownMini from "../ArrowDownMini"
import ArrowDownRightCurved from "../ArrowDownRightCurved"
import ArrowLeft from "../ArrowLeft"
import ArrowRight from "../ArrowRight"
import ArrowUp from "../ArrowUp"
import ArrowUpMini from "../ArrowUpMini"
import ArrowUpRight from "../ArrowUpRight"
import Attachment from "../Attachment"
import Bag from "../Bag"
import BarChart from "../BarChart"
import BetaBeaker from "../BetaBeaker"
import Bolt from "../Bolt"
import BoltFilled from "../BoltFilled"
import Book from "../Book"
import Bookmark from "../Bookmark"
import Bookmarks from "../Bookmarks"
import BottomLeftRadius from "../BottomLeftRadius"
import BottomPadding from "../BottomPadding"
import BottomRightRadius from "../BottomRightRadius"
import BreakLink from "../BreakLink"
import Bug from "../Bug"
import Button from "../Button"
import Calendar from "../Calendar"
import CalendarDollar from "../CalendarDollar"
import CalendarEmpty from "../CalendarEmpty"
import Camera from "../Camera"
import Cart from "../Cart"
import CartPlus from "../CartPlus"
import CenterAlign from "../CenterAlign"
import ChatConversation from "../ChatConversation"
import ChatGpt from "../ChatGpt"
import ChatMessage from "../ChatMessage"
import Check from "../Check"
import CheckCircle from "../CheckCircle"
import CheckCircleFilled from "../CheckCircleFilled"
import CheckCircleFilledMini from "../CheckCircleFilledMini"
import CheckMini from "../CheckMini"
import CheckSquare from "../CheckSquare"
import CheckSquareEmpty from "../CheckSquareEmpty"
import CheckSquareFilled from "../CheckSquareFilled"
import Circle from "../Circle"
import CircleFilled from "../CircleFilled"
import Claude from "../Claude"
import Clicks from "../Clicks"
import Clock from "../Clock"
import Close from "../Close"
import CloseCircle from "../CloseCircle"
import CloseCircleFilled from "../CloseCircleFilled"
import CloseCircleFilledMini from "../CloseCircleFilledMini"
import CloseFullScreen from "../CloseFullScreen"
import CloseMini from "../CloseMini"
import CloudCheck from "../CloudCheck"
import CloudError from "../CloudError"
import CloudUpload from "../CloudUpload"
import Code from "../Code"
import CodeFile from "../CodeFile"
import ColdSubscriber from "../ColdSubscriber"
import CollapseAll from "../CollapseAll"
import ColorPalette from "../ColorPalette"
import Columns from "../Columns"
import Content from "../Content"
import Copy from "../Copy"
import Cost from "../Cost"
import CreatorNetwork from "../CreatorNetwork"
import CreditCard from "../CreditCard"
import Crop from "../Crop"
import CropLandscape from "../CropLandscape"
import CropPortrait from "../CropPortrait"
import CropSquare from "../CropSquare"
import Crossroads from "../Crossroads"
import Cube from "../Cube"
import CustomField from "../CustomField"
import Dashboard from "../Dashboard"
import DashboardFilled from "../DashboardFilled"
import Database from "../Database"
import Delete from "../Delete"
import Design from "../Design"
import Diamond from "../Diamond"
import DeviceDesktop from "../DeviceDesktop"
import DeviceLaptop from "../DeviceLaptop"
import DeviceMobile from "../DeviceMobile"
import DeviceTablet from "../DeviceTablet"
import DevicesDesktopMobile from "../DevicesDesktopMobile"
import DollarRepeat from "../DollarRepeat"
import Down from "../Down"
import Download from "../Download"
import DownloadFile from "../DownloadFile"
import Drop from "../Drop"
import Edit from "../Edit"
import Education from "../Education"
import Email from "../Email"
import EmailAddress from "../EmailAddress"
import EmailDocument from "../EmailDocument"
import Emails from "../Emails"
import ErrorCog from "../ErrorCog"
import ExpandAll from "../ExpandAll"
import File from "../File"
import Files from "../Files"
import Filter from "../Filter"
import FilterAdd from "../FilterAdd"
import Fire from "../Fire"
import FireMini from "../FireMini"
import Flag from "../Flag"
import Flowchart from "../Flowchart"
import Folder from "../Folder"
import FolderOpen from "../FolderOpen"
import Folders from "../Folders"
import Form from "../Form"
import Gift from "../Gift"
import Give from "../Give"
import Globe from "../Globe"
import GripDots from "../GripDots"
import GripLines from "../GripLines"
import GrowingMini from "../GrowingMini"
import Heading1 from "../Heading1"
import Heading2 from "../Heading2"
import Heading3 from "../Heading3"
import Heading4 from "../Heading4"
import Heading5 from "../Heading5"
import Heading6 from "../Heading6"
import Heart from "../Heart"
import HeartFilled from "../HeartFilled"
import HeartMini from "../HeartMini"
import Highlight from "../Highlight"
import Home from "../Home"
import HomeFilled from "../HomeFilled"
import HorizontalSpacing from "../HorizontalSpacing"
import Hourglass from "../Hourglass"
import Image from "../Image"
import ImageAdd from "../ImageAdd"
import ImageGallery from "../ImageGallery"
import Inbox from "../Inbox"
import InformationCircle from "../InformationCircle"
import InlineSnippet from "../InlineSnippet"
import Keyboard from "../Keyboard"
import LandingPage from "../LandingPage"
import Layout from "../Layout"
import LayoutGrid from "../LayoutGrid"
import LayoutList from "../LayoutList"
import LayoutMasonry from "../LayoutMasonry"
import Left from "../Left"
import LeftAlign from "../LeftAlign"
import LeftPadding from "../LeftPadding"
import LetterSpacing from "../LetterSpacing"
import Lightbulb from "../Lightbulb"
import Line from "../Line"
import LineChart from "../LineChart"
import LineFile from "../LineFile"
import Link from "../Link"
import LinkTrigger from "../LinkTrigger"
import LiquidCode from "../LiquidCode"
import Lock from "../Lock"
import Logout from "../Logout"
import LongArrowDown from "../LongArrowDown"
import LongArrowLeft from "../LongArrowLeft"
import LongArrowRight from "../LongArrowRight"
import LongArrowUp from "../LongArrowUp"
import MagicWand from "../MagicWand"
import MailAdd from "../MailAdd"
import MailRemove from "../MailRemove"
import Mailbox from "../Mailbox"
import Map from "../Map"
import MapPin from "../MapPin"
import Megaphone from "../Megaphone"
import MegaphoneFilled from "../MegaphoneFilled"
import Menu from "../Menu"
import MenuHorizontal from "../MenuHorizontal"
import MenuVertical from "../MenuVertical"
import Microphone from "../Microphone"
import Minus from "../Minus"
import MinusCircle from "../MinusCircle"
import MinusSquare from "../MinusSquare"
import MinusSquareFilled from "../MinusSquareFilled"
import Money from "../Money"
import MoneyFilled from "../MoneyFilled"
import MusicNote from "../MusicNote"
import Newspaper from "../Newspaper"
import NoStatsFound from "../NoStatsFound"
import None from "../None"
import NoteMini from "../NoteMini"
import Number from "../Number"
import OnePerson from "../OnePerson"
import OpenEmailEmpty from "../OpenEmailEmpty"
import OpenEmailFile from "../OpenEmailFile"
import OpenFullScreen from "../OpenFullScreen"
import OrderedList from "../OrderedList"
import Outbox from "../Outbox"
import Pages from "../Pages"
import PaintBucket from "../PaintBucket"
import Paragraph from "../Paragraph"
import ParagraphIndentFirstLine from "../ParagraphIndentFirstLine"
import ParagraphJustifiedAlign from "../ParagraphJustifiedAlign"
import ParagraphSpacing from "../ParagraphSpacing"
import Pause from "../Pause"
import Payment from "../Payment"
import PDFFile from "../PdfFile"
import PencilWrite from "../PencilWrite"
import Percent from "../Percent"
import PercentDiscount from "../PercentDiscount"
import PersonAdd from "../PersonAdd"
import Personalization from "../Personalization"
import PersonRemove from "../PersonRemove"
import Phone from "../Phone"
import PieChart from "../PieChart"
import PiggyBank from "../PiggyBank"
import Pin from "../Pin"
import PinRemove from "../PinRemove"
import Play from "../Play"
import PlayCircle from "../PlayCircle"
import PlayPause from "../PlayPause"
import Plug from "../Plug"
import Plus from "../Plus"
import PlusCircle from "../PlusCircle"
import PlusCircleFilled from "../PlusCircleFilled"
import Print from "../Print"
import Profile from "../Profile"
import Puzzle from "../Puzzle"
import QuestionCircle from "../QuestionCircle"
import Quote from "../Quote"
import Rec from "../Rec"
import ReceiptSlip from "../ReceiptSlip"
import RecommendationIncoming from "../RecommendationIncoming"
import RecommendationIncomingOnly from "../RecommendationIncomingOnly"
import RecommendationOutgoing from "../RecommendationOutgoing"
import RecommendationOutgoingOnly from "../RecommendationOutgoingOnly"
import RecommendationPaid from "../RecommendationPaid"
import RecommendationReciprocated from "../RecommendationReciprocated"
import RecList from "../RecList"
import RecPaid from "../RecPaid"
import RecPerson from "../RecPerson"
import Redo from "../Redo"
import Refresh from "../Refresh"
import RemoveFromFolder from "../RemoveFromFolder"
import Repeat from "../Repeat"
import Reply from "../Reply"
import ReplyAll from "../ReplyAll"
import Resize from "../Resize"
import Right from "../Right"
import RightAlign from "../RightAlign"
import RightPadding from "../RightPadding"
import Rocket from "../Rocket"
import Route from "../Route"
import RSS from "../Rss"
import Rules from "../Rules"
import Save from "../Save"
import Search from "../Search"
import Section from "../Section"
import Security from "../Security"
import Segment from "../Segment"
import Send from "../Send"
import SendScheduled from "../SendScheduled"
import SEO from "../Seo"
import SettingsCog from "../SettingsCog"
import SettingsCogFilled from "../SettingsCogFilled"
import SettingsSliders from "../SettingsSliders"
import SettingsTune from "../SettingsTune"
import SettingsWrench from "../SettingsWrench"
import Share from "../Share"
import SidebarLeft from "../SidebarLeft"
import SidebarRight from "../SidebarRight"
import Signals from "../Signals"
import Slash from "../Slash"
import Slideshow from "../Slideshow"
import SmartToy from "../SmartToy"
import Sort from "../Sort"
import Sparkle from "../Sparkle"
import Stairs from "../Stairs"
import Star from "../Star"
import StarCircle from "../StarCircle"
import StarFilled from "../StarFilled"
import Stopwatch from "../Stopwatch"
import Support from "../Support"
import SwatchBook from "../SwatchBook"
import Table from "../Table"
import Tag from "../Tag"
import TagTrigger from "../TagTrigger"
import TagMinus from "../TagMinus"
import TagMoney from "../TagMoney"
import TagPlus from "../TagPlus"
import Target from "../Target"
import Tasks from "../Tasks"
import Template from "../Template"
import Text from "../Text"
import TextBold from "../TextBold"
import TextItalic from "../TextItalic"
import TextSize from "../TextSize"
import TextStrikethrough from "../TextStrikethrough"
import TextUnderline from "../TextUnderline"
import ThreePeople from "../ThreePeople"
import ThreePeopleFilled from "../ThreePeopleFilled"
import TipJar from "../TipJar"
import Tools from "../Tools"
import TopLeftRadius from "../TopLeftRadius"
import TopPadding from "../TopPadding"
import TopRightRadius from "../TopRightRadius"
import TrendingDown from "../TrendingDown"
import TrendingDownMini from "../TrendingDownMini"
import TrendingUp from "../TrendingUp"
import TrendingUpMini from "../TrendingUpMini"
import Trophy from "../Trophy"
import TwoPeople from "../TwoPeople"
import Undo from "../Undo"
import Unlock from "../Unlock"
import UnorderedList from "../UnorderedList"
import Up from "../Up"
import Upload from "../Upload"
import UploadFile from "../UploadFile"
import UserFile from "../UserFile"
import VennDiagram from "../VennDiagram"
import VerticalAlignBottom from "../VerticalAlignBottom"
import VerticalAlignMiddle from "../VerticalAlignMiddle"
import VerticalAlignTop from "../VerticalAlignTop"
import VerticalSpacing from "../VerticalSpacing"
import Video from "../Video"
import View from "../View"
import ViewOff from "../ViewOff"
import Wallet from "../Wallet"
import WordPress from "../WordPress"

const library = [
  {
    name: "ab-testing",
    component: ABTesting
  },
  {
    name: "ad",
    component: Ad
  },
  {
    name: "address-book",
    component: AddressBook
  },
  {
    name: "admin",
    component: Admin
  },
  {
    name: "alarm",
    component: Alarm
  },
  {
    name: "alarm-off",
    component: AlarmOff
  },
  {
    name: "alarm-ring",
    component: AlarmRing
  },
  {
    name: "alert-circle",
    component: AlertCircle
  },
  {
    name: "alert-triangle",
    component: AlertTriangle
  },
  {
    name: "analytics",
    component: Analytics
  },
  {
    name: "announcement",
    component: Announcement
  },
  {
    name: "app-store",
    component: AppStore
  },
  {
    name: "app-store-filled",
    component: AppStoreFilled
  },
  {
    name: "archive",
    component: Archive
  },
  {
    name: "arrow-down",
    component: ArrowDown
  },
  {
    name: "arrow-down-mini",
    component: ArrowDownMini
  },
  {
    name: "arrow-down-right-curved",
    component: ArrowDownRightCurved
  },
  {
    name: "arrow-left",
    component: ArrowLeft
  },
  {
    name: "arrow-right",
    component: ArrowRight
  },
  {
    name: "arrow-up",
    component: ArrowUp
  },
  {
    name: "arrow-up-mini",
    component: ArrowUpMini
  },
  {
    name: "arrow-up-right",
    component: ArrowUpRight
  },
  {
    name: "attachment",
    component: Attachment
  },
  {
    name: "bag",
    component: Bag
  },
  {
    name: "bar-chart",
    component: BarChart
  },
  {
    name: "beta-beaker",
    component: BetaBeaker
  },
  {
    name: "bolt",
    component: Bolt
  },
  {
    name: "bolt-filled",
    component: BoltFilled
  },
  {
    name: "book",
    component: Book
  },
  {
    name: "bookmark",
    component: Bookmark
  },
  {
    name: "bookmarks",
    component: Bookmarks
  },
  {
    name: "bottom-left-radius",
    component: BottomLeftRadius
  },
  {
    name: "bottom-padding",
    component: BottomPadding
  },
  {
    name: "bottom-right-radius",
    component: BottomRightRadius
  },
  {
    name: "break-link",
    component: BreakLink
  },
  {
    name: "bug",
    component: Bug
  },
  {
    name: "button",
    component: Button
  },
  {
    name: "calendar",
    component: Calendar
  },
  {
    name: "calendar-dollar",
    component: CalendarDollar
  },
  {
    name: "calendar-empty",
    component: CalendarEmpty
  },
  {
    name: "camera",
    component: Camera
  },
  {
    name: "cart",
    component: Cart
  },
  {
    name: "cart-plus",
    component: CartPlus
  },
  {
    name: "center-align",
    component: CenterAlign
  },
  {
    name: "chat-conversation",
    component: ChatConversation
  },
  {
    name: "chat-gpt",
    component: ChatGpt
  },
  {
    name: "chat-message",
    component: ChatMessage
  },
  {
    name: "check",
    component: Check
  },
  {
    name: "check-circle",
    component: CheckCircle
  },
  {
    name: "check-circle-filled",
    component: CheckCircleFilled
  },
  {
    name: "check-circle-filled-mini",
    component: CheckCircleFilledMini
  },
  {
    name: "check-mini",
    component: CheckMini
  },
  {
    name: "check-square",
    component: CheckSquare
  },
  {
    name: "check-square-empty",
    component: CheckSquareEmpty
  },
  {
    name: "check-square-filled",
    component: CheckSquareFilled
  },
  {
    name: "circle",
    component: Circle
  },
  {
    name: "circle-filled",
    component: CircleFilled
  },
  {
    name: "claude",
    component: Claude
  },
  {
    name: "clicks",
    component: Clicks
  },
  {
    name: "clock",
    component: Clock
  },
  {
    name: "close",
    component: Close
  },
  {
    name: "close-circle",
    component: CloseCircle
  },
  {
    name: "close-circle-filled",
    component: CloseCircleFilled
  },
  {
    name: "close-circle-filled-mini",
    component: CloseCircleFilledMini
  },
  {
    name: "close-fullscreen",
    component: CloseFullScreen
  },
  {
    name: "close-mini",
    component: CloseMini
  },
  {
    name: "cloud-check",
    component: CloudCheck
  },
  {
    name: "cloud-error",
    component: CloudError
  },
  {
    name: "cloud-upload",
    component: CloudUpload
  },
  {
    name: "code",
    component: Code
  },
  {
    name: "code-file",
    component: CodeFile
  },
  {
    name: "cold-subscriber",
    component: ColdSubscriber
  },
  {
    name: "collapse-all",
    component: CollapseAll
  },
  {
    name: "color-palette",
    component: ColorPalette
  },
  {
    name: "columns",
    component: Columns
  },
  {
    name: "content",
    component: Content
  },
  {
    name: "copy",
    component: Copy
  },
  {
    name: "cost",
    component: Cost
  },
  {
    name: "creator-network",
    component: CreatorNetwork
  },
  {
    name: "credit-card",
    component: CreditCard
  },
  {
    name: "crop",
    component: Crop
  },
  {
    name: "crop-landscape",
    component: CropLandscape
  },
  {
    name: "crop-portrait",
    component: CropPortrait
  },
  {
    name: "crop-square",
    component: CropSquare
  },
  {
    name: "crossroads",
    component: Crossroads
  },
  {
    name: "cube",
    component: Cube
  },
  {
    name: "custom-field",
    component: CustomField
  },
  {
    name: "dashboard",
    component: Dashboard
  },
  {
    name: "dashboard-filled",
    component: DashboardFilled
  },
  {
    name: "database",
    component: Database
  },
  {
    name: "delete",
    component: Delete
  },
  {
    name: "design",
    component: Design
  },
  {
    name: "diamond",
    component: Diamond
  },
  {
    name: "device-desktop",
    component: DeviceDesktop
  },
  {
    name: "device-laptop",
    component: DeviceLaptop
  },
  {
    name: "device-mobile",
    component: DeviceMobile
  },
  {
    name: "devices-desktop-mobile",
    component: DevicesDesktopMobile
  },
  {
    name: "device-tablet",
    component: DeviceTablet
  },
  {
    name: "dollar-repeat",
    component: DollarRepeat
  },
  {
    name: "down",
    component: Down
  },
  {
    name: "download",
    component: Download
  },
  {
    name: "download-file",
    component: DownloadFile
  },
  {
    name: "drop",
    component: Drop
  },
  {
    name: "edit",
    component: Edit
  },
  {
    name: "education",
    component: Education
  },
  {
    name: "email",
    component: Email
  },
  {
    name: "email-address",
    component: EmailAddress
  },
  {
    name: "email-document",
    component: EmailDocument
  },
  {
    name: "emails",
    component: Emails
  },
  {
    name: "error-cog",
    component: ErrorCog
  },
  {
    name: "expand-all",
    component: ExpandAll
  },
  {
    name: "file",
    component: File
  },
  {
    name: "files",
    component: Files
  },
  {
    name: "filter",
    component: Filter
  },
  {
    name: "filter-add",
    component: FilterAdd
  },
  {
    name: "fire",
    component: Fire
  },
  {
    name: "fire-mini",
    component: FireMini
  },
  {
    name: "flag",
    component: Flag
  },
  {
    name: "flowchart",
    component: Flowchart
  },
  {
    name: "folder",
    component: Folder
  },
  {
    name: "folder-open",
    component: FolderOpen
  },
  {
    name: "folders",
    component: Folders
  },
  {
    name: "form",
    component: Form
  },
  {
    name: "gift",
    component: Gift
  },
  {
    name: "give",
    component: Give
  },
  {
    name: "globe",
    component: Globe
  },
  {
    name: "grip-dots",
    component: GripDots
  },
  {
    name: "grip-lines",
    component: GripLines
  },
  {
    name: "growing-mini",
    component: GrowingMini
  },
  {
    name: "heading-1",
    component: Heading1
  },
  {
    name: "heading-2",
    component: Heading2
  },
  {
    name: "heading-3",
    component: Heading3
  },
  {
    name: "heading-4",
    component: Heading4
  },
  {
    name: "heading-5",
    component: Heading5
  },
  {
    name: "heading-6",
    component: Heading6
  },
  {
    name: "heart",
    component: Heart
  },
  {
    name: "heart-filled",
    component: HeartFilled
  },
  {
    name: "heart-mini",
    component: HeartMini
  },
  {
    name: "highlight",
    component: Highlight
  },
  {
    name: "home",
    component: Home
  },
  {
    name: "home-filled",
    component: HomeFilled
  },
  {
    name: "horizontal-spacing",
    component: HorizontalSpacing
  },
  {
    name: "hourglass",
    component: Hourglass
  },
  {
    name: "image",
    component: Image
  },
  {
    name: "image-add",
    component: ImageAdd
  },
  {
    name: "image-gallery",
    component: ImageGallery
  },
  {
    name: "inbox",
    component: Inbox
  },
  {
    name: "information-circle",
    component: InformationCircle
  },
  {
    name: "inline-snippet",
    component: InlineSnippet
  },
  {
    name: "keyboard",
    component: Keyboard
  },
  {
    name: "landing-page",
    component: LandingPage
  },
  {
    name: "layout",
    component: Layout
  },
  {
    name: "layout-grid",
    component: LayoutGrid
  },
  {
    name: "layout-list",
    component: LayoutList
  },
  {
    name: "layout-masonry",
    component: LayoutMasonry
  },
  {
    name: "left",
    component: Left
  },
  {
    name: "left-align",
    component: LeftAlign
  },
  {
    name: "left-padding",
    component: LeftPadding
  },
  {
    name: "letter-spacing",
    component: LetterSpacing
  },
  {
    name: "lightbulb",
    component: Lightbulb
  },
  {
    name: "line",
    component: Line
  },
  {
    name: "line-chart",
    component: LineChart
  },
  {
    name: "line-file",
    component: LineFile
  },
  {
    name: "link",
    component: Link
  },
  {
    name: "link-trigger",
    component: LinkTrigger
  },
  {
    name: "liquid-code",
    component: LiquidCode
  },
  {
    name: "lock",
    component: Lock
  },
  {
    name: "log-out",
    component: Logout
  },
  {
    name: "long-arrow-down",
    component: LongArrowDown
  },
  {
    name: "long-arrow-left",
    component: LongArrowLeft
  },
  {
    name: "long-arrow-right",
    component: LongArrowRight
  },
  {
    name: "long-arrow-up",
    component: LongArrowUp
  },
  {
    name: "magic-wand",
    component: MagicWand
  },
  {
    name: "mail-add",
    component: MailAdd
  },
  {
    name: "mailbox",
    component: Mailbox
  },
  {
    name: "mail-remove",
    component: MailRemove
  },
  {
    name: "map",
    component: Map
  },
  {
    name: "map-pin",
    component: MapPin
  },
  {
    name: "megaphone",
    component: Megaphone
  },
  {
    name: "megaphone-filled",
    component: MegaphoneFilled
  },
  {
    name: "menu",
    component: Menu
  },
  {
    name: "menu-horizontal",
    component: MenuHorizontal
  },
  {
    name: "menu-vertical",
    component: MenuVertical
  },
  {
    name: "microphone",
    component: Microphone
  },
  {
    name: "minus",
    component: Minus
  },
  {
    name: "minus-circle",
    component: MinusCircle
  },
  {
    name: "minus-square",
    component: MinusSquare
  },
  {
    name: "minus-square-filled",
    component: MinusSquareFilled
  },
  {
    name: "money",
    component: Money
  },
  {
    name: "money-filled",
    component: MoneyFilled
  },
  {
    name: "music-note",
    component: MusicNote
  },
  {
    name: "newspaper",
    component: Newspaper
  },
  {
    name: "none",
    component: None
  },
  {
    name: "no-stats-found",
    component: NoStatsFound
  },
  {
    name: "note-mini",
    component: NoteMini
  },
  {
    name: "number",
    component: Number
  },
  {
    name: "one-person",
    component: OnePerson
  },
  {
    name: "open-email-empty",
    component: OpenEmailEmpty
  },
  {
    name: "open-email-file",
    component: OpenEmailFile
  },
  {
    name: "open-fullscreen",
    component: OpenFullScreen
  },
  {
    name: "ordered-list",
    component: OrderedList
  },
  {
    name: "outbox",
    component: Outbox
  },
  {
    name: "pages",
    component: Pages
  },
  {
    name: "paint-bucket",
    component: PaintBucket
  },
  {
    name: "paragraph",
    component: Paragraph
  },
  {
    name: "paragraph-indent-first-line",
    component: ParagraphIndentFirstLine
  },
  {
    name: "paragraph-justified-align",
    component: ParagraphJustifiedAlign
  },
  {
    name: "paragraph-spacing",
    component: ParagraphSpacing
  },
  {
    name: "pause",
    component: Pause
  },
  {
    name: "payment",
    component: Payment
  },
  {
    name: "pdf-file",
    component: PDFFile
  },
  {
    name: "pencil-write",
    component: PencilWrite
  },
  {
    name: "percent",
    component: Percent
  },
  {
    name: "percent-discount",
    component: PercentDiscount
  },
  {
    name: "person-add",
    component: PersonAdd
  },
  {
    name: "personalization",
    component: Personalization
  },
  {
    name: "person-remove",
    component: PersonRemove
  },
  {
    name: "phone",
    component: Phone
  },
  {
    name: "pie-chart",
    component: PieChart
  },
  {
    name: "piggy-bank",
    component: PiggyBank
  },
  {
    name: "pin",
    component: Pin
  },
  {
    name: "pin-remove",
    component: PinRemove
  },
  {
    name: "play",
    component: Play
  },
  {
    name: "play-circle",
    component: PlayCircle
  },
  {
    name: "play-pause",
    component: PlayPause
  },
  {
    name: "plug",
    component: Plug
  },
  {
    name: "plus",
    component: Plus
  },
  {
    name: "plus-circle",
    component: PlusCircle
  },
  {
    name: "plus-circle-filled",
    component: PlusCircleFilled
  },
  {
    name: "print",
    component: Print
  },
  {
    name: "profile",
    component: Profile
  },
  {
    name: "puzzle",
    component: Puzzle
  },
  {
    name: "question-circle",
    component: QuestionCircle
  },
  {
    name: "quote",
    component: Quote
  },
  {
    name: "rec",
    component: Rec
  },
  {
    name: "receipt-slip",
    component: ReceiptSlip
  },
  {
    name: "recommendation-incoming",
    component: RecommendationIncoming
  },
  {
    name: "recommendation-incoming-only",
    component: RecommendationIncomingOnly
  },
  {
    name: "recommendation-outgoing",
    component: RecommendationOutgoing
  },
  {
    name: "recommendation-outgoing-only",
    component: RecommendationOutgoingOnly
  },
  {
    name: "recommendation-paid",
    component: RecommendationPaid
  },
  {
    name: "recommendation-reciprocated",
    component: RecommendationReciprocated
  },
  {
    name: "rec-list",
    component: RecList
  },
  {
    name: "rec-paid",
    component: RecPaid
  },
  {
    name: "rec-person",
    component: RecPerson
  },
  {
    name: "redo",
    component: Redo
  },
  {
    name: "refresh",
    component: Refresh
  },
  {
    name: "remove-from-folder",
    component: RemoveFromFolder
  },
  {
    name: "repeat",
    component: Repeat
  },
  {
    name: "reply",
    component: Reply
  },
  {
    name: "reply-all",
    component: ReplyAll
  },
  {
    name: "resize",
    component: Resize
  },
  {
    name: "right",
    component: Right
  },
  {
    name: "right-align",
    component: RightAlign
  },
  {
    name: "right-padding",
    component: RightPadding
  },
  {
    name: "rocket",
    component: Rocket
  },
  {
    name: "route",
    component: Route
  },
  {
    name: "rss",
    component: RSS
  },
  {
    name: "rules",
    component: Rules
  },
  {
    name: "save",
    component: Save
  },
  {
    name: "search",
    component: Search
  },
  {
    name: "section",
    component: Section
  },
  {
    name: "security",
    component: Security
  },
  {
    name: "segment",
    component: Segment
  },
  {
    name: "send",
    component: Send
  },
  {
    name: "send-scheduled",
    component: SendScheduled
  },
  {
    name: "seo",
    component: SEO
  },
  {
    name: "settings-cog",
    component: SettingsCog
  },
  {
    name: "settings-cog-filled",
    component: SettingsCogFilled
  },
  {
    name: "settings-sliders",
    component: SettingsSliders
  },
  {
    name: "settings-tune",
    component: SettingsTune
  },
  {
    name: "settings-wrench",
    component: SettingsWrench
  },
  {
    name: "share",
    component: Share
  },
  {
    name: "sidebar-left",
    component: SidebarLeft
  },
  {
    name: "sidebar-right",
    component: SidebarRight
  },
  {
    name: "signals",
    component: Signals
  },
  {
    name: "slash",
    component: Slash
  },
  {
    name: "slideshow",
    component: Slideshow
  },
  {
    name: "smart-toy",
    component: SmartToy
  },
  {
    name: "sort",
    component: Sort
  },
  {
    name: "sparkle",
    component: Sparkle
  },
  {
    name: "stairs",
    component: Stairs
  },
  {
    name: "star",
    component: Star
  },
  {
    name: "star-circle",
    component: StarCircle
  },
  {
    name: "star-filled",
    component: StarFilled
  },
  {
    name: "stopwatch",
    component: Stopwatch
  },
  {
    name: "support",
    component: Support
  },
  {
    name: "swatch-book",
    component: SwatchBook
  },
  {
    name: "table",
    component: Table
  },
  {
    name: "tag",
    component: Tag
  },
  {
    name: "tag-minus",
    component: TagMinus
  },
  {
    name: "tag-money",
    component: TagMoney
  },
  {
    name: "tag-plus",
    component: TagPlus
  },
  {
    name: "tag-trigger",
    component: TagTrigger
  },
  {
    name: "target",
    component: Target
  },
  {
    name: "tasks",
    component: Tasks
  },
  {
    name: "template",
    component: Template
  },
  {
    name: "text",
    component: Text
  },
  {
    name: "text-bold",
    component: TextBold
  },
  {
    name: "text-italic",
    component: TextItalic
  },
  {
    name: "text-size",
    component: TextSize
  },
  {
    name: "text-strikethrough",
    component: TextStrikethrough
  },
  {
    name: "text-underline",
    component: TextUnderline
  },
  {
    name: "three-people",
    component: ThreePeople
  },
  {
    name: "three-people-filled",
    component: ThreePeopleFilled
  },
  {
    name: "tip-jar",
    component: TipJar
  },
  {
    name: "tools",
    component: Tools
  },
  {
    name: "top-left-radius",
    component: TopLeftRadius
  },
  {
    name: "top-padding",
    component: TopPadding
  },
  {
    name: "top-right-radius",
    component: TopRightRadius
  },
  {
    name: "trending-down",
    component: TrendingDown
  },
  {
    name: "trending-down-mini",
    component: TrendingDownMini
  },
  {
    name: "trending-up",
    component: TrendingUp
  },
  {
    name: "trending-up-mini",
    component: TrendingUpMini
  },
  {
    name: "trophy",
    component: Trophy
  },
  {
    name: "two-people",
    component: TwoPeople
  },
  {
    name: "undo",
    component: Undo
  },
  {
    name: "unlock",
    component: Unlock
  },
  {
    name: "unordered-list",
    component: UnorderedList
  },
  {
    name: "up",
    component: Up
  },
  {
    name: "upload",
    component: Upload
  },
  {
    name: "upload-file",
    component: UploadFile
  },
  {
    name: "user-file",
    component: UserFile
  },
  {
    name: "venn-diagram",
    component: VennDiagram
  },
  {
    name: "vertical-align-bottom",
    component: VerticalAlignBottom
  },
  {
    name: "vertical-align-middle",
    component: VerticalAlignMiddle
  },
  {
    name: "vertical-align-top",
    component: VerticalAlignTop
  },
  {
    name: "vertical-spacing",
    component: VerticalSpacing
  },
  {
    name: "video",
    component: Video
  },
  {
    name: "view",
    component: View
  },
  {
    name: "view-off",
    component: ViewOff
  },
  {
    name: "wallet",
    component: Wallet
  },
  {
    name: "wordpress",
    component: WordPress
  }
] as const

export type IconName = (typeof library)[number]["name"]

export default library
